import { useState, useEffect } from 'react';
import { Event } from "@/types/event/event";
import { Price } from "@/types/checkout/checkout";
import { getEventDetails } from '@/services/event/fetchEventDetails';
import { getPricesForEvent } from '@/services/ticket/getPricesForEvent';
import { getTicketsAvailableForPrices } from '@/services/ticket/getTicketsAvailable';

export const useEventData = (uuid: string | undefined, navigate: (path: string, state?: any) => void) => {
    const [event, setEvent] = useState<Event | null>(null);
    const [prices, setPrices] = useState<Price[]>([]);
    const [eventTicketsLeft, setEventTicketsLeft] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!uuid) return;

        const fetchData = async () => {
            try {
                const [eventData, pricesData] = await Promise.all([
                    getEventDetails(uuid),
                    getPricesForEvent(uuid)
                ]);

                setEvent(eventData);
                const pricesWithTickets = await getTicketsAvailableForPrices(pricesData);
                setPrices(pricesWithTickets);
                
                // Calculate total tickets left by summing up available tickets from each price tier
                const totalTicketsLeft = pricesWithTickets.reduce((sum, price) => sum + (price.tickets_available || 0), 0);
                setEventTicketsLeft(totalTicketsLeft);
                
                setTimeout(() => setLoading(false), 1000);
            } catch (error) {
                console.error('Error fetching data:', error);
                navigate('/error', { state: { errorCode: error instanceof Error ? error.message : 'Unknown error' } });
            }
        };

        fetchData();
    }, [uuid, navigate]);

    return { event, prices, eventTicketsLeft, loading };
}; 